import { useCallback, useEffect, useState } from "react";
import { getFavorites, toggleFavorite } from "@/utils/storage";

export default function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(getFavorites());
  }, []);

  const toggle = useCallback((id: string) => {
    setFavorites(toggleFavorite(id));
  }, []);

  const isFav = useCallback(
    (id: string) => favorites.includes(id),
    [favorites],
  );

  return { favorites, toggle, isFav };
}